import React, {useContext, useEffect} from "react";
import parse from "html-react-parser";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component is used to show company notes .
    let Record = useContext(RecordsManagementContext)
    let EstimateAndCompanyInfoData = Record.CP_PageDetails.EstimateAndCompanyInfo
    if (EstimateAndCompanyInfoData.CompanyText === null || EstimateAndCompanyInfoData.CompanyText === '') {
        return <></>;
    } else {
        return (
            <div className="row pt-3" style={Record.SignatureLoad ? {
                pointerEvents: "none", opacity: "0.3",zIndex:800
            } : {}}>
                <div className="col-md-12">
                    <div className="content-p">
                        <p className="mb-0">
                            {parse(`${EstimateAndCompanyInfoData.CompanyText}`)}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
};
